<template lang="pug">
.logozone
  .logozone-intro
    AppTitle(:title="$t('mantra')")

    Query(
      ref="query"
      :initialValue="artworks"
      :query="require('~/graphql/Artwork.gql').Artworks"
      :limit="12"
      :variables="{ query, type: 'LOGO' }"
      v-slot="{ items, isFetching }"
    )
      .grid.is-widescreen-6.is-desktop-7.is-tablet-8.is-logozone
        .column
          .logozone-search
            TextInput(
              name="search"
              type="search"
              label=""
              v-model="searchQuery"
            )

      .grid.is-ultrawide-2.is-widescreen-3.is-desktop-4.is-6.is-logozone.u-mt-sm
        .column(v-for="logo in items")
          AppCard.is-small.u-textCenter(:img="logo.thumb" ratio="1:1" :title="logo.title" :url="`/tools/doodles/logos/${logo.slug}`" @click="selectedItem = logo")

  TheaterOverlay(
    :isActive="!!selectedItem.id"
    :title="selectedItem.title"
    :image="selectedItem.thumb"
    @close="onLeave"
  )
    //- template(#buttons)
    //-   a.patternest-overlay-download(v-if="selectedItem" :href="`/files/${selectedItem.file.id}`")
    //-     AppIcon(name="download")

</template>

<script>
import { debounce } from 'throttle-debounce';
import { load } from '~/directives';
import { generateSeoMeta } from '~/utils/seo';
import TextInput from '~/components/inputs/TextInput';
import Query from '~/components/Query';
import TheaterOverlay from '~/components/TheaterOverlay';
import { Artworks, Artwork } from '~/graphql/Artwork.gql';

export default {
  key: 'logos',
  preserveScrollPosition: true,
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true }),
  directives: {
    load
  },
  components: {
    TextInput,
    Query,
    TheaterOverlay
  },
  meta: {
    theme: 'logozone',
    logoIcon: 'logoZoneIcon',
    logoText: 'logoZoneTypo'
  },
  async asyncData({ app, params, from }) {
    if (from && from.name.indexOf('ideas-graphics-logos-slug') === 0) {
      return {};
    }

    const [artworks, artwork] = await Promise.all([
      app.$api.query({
        query: Artworks,
        variables: {
          first: 12,
          type: 'LOGO'
        }
      }),
      params.slug
        ? app.$api.query({
            query: Artwork,
            variables: {
              slug: params.slug
            }
          })
        : undefined
    ]);

    let selectedItem = {
      id: null,
      thumb: '',
      title: '',
      file: {
        id: ''
      }
    };

    if (artwork) {
      selectedItem = artwork.data.artwork;
    }

    return {
      artworks: artworks.data.artworks,
      selectedItem
    };
  },
  data: () => ({
    query: '',
    searchQuery: '',
    selectedItem: {
      id: null,
      thumb: '',
      title: '',
      file: {
        id: ''
      }
    }
  }),
  watch: {
    searchQuery(value) {
      this.updateQuery(value);
    }
  },
  methods: {
    onLeave() {
      this.selectedItem = {
        id: null,
        thumb: '',
        title: '',
        file: {
          id: ''
        }
      };
      this.$router.localePush('/tools/doodles/logos');
    },
    updateQuery: debounce(400, function(value) {
      this.query = value;
    })
  }
};
</script>

<style lang="stylus">
div.app.is-logozone
  overflow: hidden

  .theater-overlay
    &-title
      color: $clBlack

    &-icons
      color: $clBlack

      >*
        margin: 0 5px

      .icon
        color: $clBlack
        fill: $clBlack

        &:hover
          fill: $clPrimary

.logozone
  h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6, .button-link
    font-weight: $fontWeight-medium

  &-share
    margin: 0 -5px

    >a
      margin: 5px

  &-intro
    padding-top: unitRes(50, 200)
    position: relative
    z-index: 2

  &-search
    position: relative

    .button
      position: absolute
      top: 0
      right: 0
      margin: 0
      height: 100%

      &:hover
        background: $clPrimary !important
        color: $clWhite !important
        border-color: $clPrimary !important

  .grid.is-logozone
    margin-right: gr(-40)
    margin-left: gr(-40)

    >.column
      padding-right: gr(40)
      padding-left: gr(40)
</style>

<i18n>
{
  "en": {
    "pageTitle":"Logos",
    "pageDesc":"Different logo types starting from typo to icons, all different shapes to inspire you in your next branding project.",
    "mantra":"Inspiring concepts |and explorations.",
    "search":"Search"
  },
  "ar": {
    "pageTitle":"الشعارات",
    "pageDesc":"أنواع مختلفة من الشعارات بداية من التايبوجرافي إلى الأيقونات، ستجد جميع الأشكال المختلفة التي تُلهمك في مشروعك القادم.",
    "mantra":"شعارات مُلهمة لأفكار |تصميمية أكثر تميزًا.",
    "search":"بحث"
  }
}
</i18n>
